<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.balanceRecords'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow :narrows="narrows" @narrowSelect="narrowSelect" />
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :loading="loading"
        id="balancesTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="content"
          :title="$t('balance.content')"
          min-width="60"
        />
        <vxe-table-column field="fee" :title="$t('balance.fee')" min-width="80">
          <template v-slot="{ row }">
            <span :class="row.type == 'in' && row.fee > 0 ? 'green' : 'red'">
              {{ row.fee | currency }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="payMethodName"
          :title="$t('balance.payMethod')"
          min-width="60"
        />
        <vxe-table-column
          field="voucher"
          :title="$t('payment.voucher')"
          min-width="70"
        >
          <template v-slot="{ row }">
            <thumbnail-text :srcs="row.voucher" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.remark" :number="10" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="operator"
          :title="$t('balance.operator')"
          min-width="60"
        />
        <vxe-table-column
          field="createdAt"
          :title="$t('text.createAt')"
          min-width="110"
        />

        <vxe-table-column
          field="balanceAudit"
          :title="$t('verify.dealType')"
          min-width="70"
        >
          <template v-slot="{ row }">
            <span
              v-if="row.balanceAudit != null"
              :class="
                row.balanceAudit.dealType == 'agree' ? 'green-shallow' : 'red'
              "
              >{{ $t("verifyInfos." + row.balanceAudit.dealType) }}</span
            >
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="commentAt"
          :title="$t('verify.commentAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <span v-if="row.balanceAudit != null">{{
              row.balanceAudit.commentAt
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="commentName"
          :title="$t('verify.commentName')"
          min-width="70"
        >
          <template v-slot="{ row }">
            <span v-if="row.balanceAudit != null">{{
              row.balanceAudit.commentName
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="comment"
          :title="$t('verify.comment')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              v-if="row.balanceAudit != null"
              :content="row.balanceAudit.comment"
              :number="10"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          min-width="90"
        >
          <template v-slot="{ row, rowIndex }">
            <span
              v-if="
                row.type == 'in' &&
                (row.balanceAudit == null ||
                  (row.balanceAudit != null &&
                    row.balanceAudit.dealType == 'reject'))
              "
            >
              <el-button type="text" size="mini" @click="edit(row, rowIndex)">{{
                $t("text.edit")
              }}</el-button>
              <el-button type="text" size="mini" @click="deleteRow(row)">{{
                $t("text.delete")
              }}</el-button>
            </span>
          </template>
        </vxe-table-column>
      </vxe-table>

      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="30%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="80px">
        <el-form-item
          :label="$t('customer.rechargeAmount')"
          :prop="'fee'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('customer.rechargeAmount')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editObj.fee"
            :placeholder="$t('customer.rechargeAmount')"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="$t('balance.payMethod')"
          :prop="'payMethodId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('balance.payMethod')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="editObj.payMethodId"
            filterable
            clearable
          >
            <el-option
              v-for="payMethod in payMethods"
              :key="payMethod.id"
              :label="payMethod.name"
              :value="payMethod.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('text.remark')" :prop="'remark'">
          <el-input
            size="small"
            v-model.trim="editObj.remark"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('payment.voucher')" :prop="'voucher'">
          <dropzone v-model="editObj.voucher" multiple />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editSubmitDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Thumbnail from "@/components/Thumbnail";
import ThumbnailText from "@/components/ThumbnailText";

import Dropzone from "@/components/Dropzone";
import BalanceInOut from "@/api/balanceInOut.js";
import PayMethod from "@/api/payMethod.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Thumbnail,
    ThumbnailText,
    RawHtmlLimitNumber,
    Dropzone,
  },
  data() {
    return {
      Util: Util,
      narrows: [
        [
          {
            label: this.$t("balance.conditions"),
            items: [
              {
                label: this.$t("balance.in"),
                key: "in",
                condition: { type: "in" },
              },
              {
                label: this.$t("balance.out"),
                key: "out",
                condition: { type: "out" },
              },
            ],
          },
          {
            label: this.$t("verify.dealType"),
            items: [
              {
                label: this.$t("verifyInfos.agree"),
                key: "agree",
                condition: { balanceVerify: "agree" },
              },
              {
                label: this.$t("verifyInfos.reject"),
                key: "reject",
                condition: { balanceVerify: "reject" },
              },
              {
                label: this.$t("verifyInfos.no"),
                key: "no",
                condition: { balanceVerify: "no" },
              },
            ],
          },
        ],
      ],
      sorter: {
        sortBy: "balanceInOuts_id",
        sortIndicator: "desc",
      },
      // 编辑
      editDF: false,
      row: null,
      rowIndex: null,
      payMethods: [],
      editObj: {
        fee: null,
        payMethodId: null,
        payMethodName: null,
        remark: null,
        voucher: null,
      },
      editSubmitDoing: false,
    };
  },
  computed: {
    implicit() {
      return {
        customerId: this.$route.params.id,
      };
    },
  },
  created() {
    const self = this;
  },
  methods: {
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        BalanceInOut.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    //
    edit(row, rowIndex) {
      const self = this;
      self.row = row;
      self.rowIndex = rowIndex;
      self.editObj.fee = row.fee;
      self.editObj.payMethodId = row.payMethodId;
      self.editObj.payMethodName = row.payMethodName;
      self.editObj.remark = row.remark;
      self.editObj.voucher = row.voucher;
      self.editSubmitDoing = false;
      PayMethod.findByTypes({ types: PayMethod.balanceTypes }).then(function (
        res
      ) {
        if (res.status === 200) {
          self.payMethods = res.data;
          self.editDF = true;
        } else {
          self.sysError();
        }
      });
    },
    editSubmit() {
      const self = this;
      this.$refs.editObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexPrice(self.editObj.fee)) {
            self.$message({
              message: self.$t("rules.regex", [
                self.$t("customer.rechargeAmount"),
              ]),
              type: "warning",
            });
            return;
          }
          self.editObj.payMethodName = self.payMethods.find(
            (p) => p.id === self.editObj.payMethodId
          ).name;
          self.editSubmitDoing = true;
          BalanceInOut.update(self.row.id, self.editObj).then(function (res) {
            self.editSubmitDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.records[self.rowIndex].fee = self.editObj.fee;
              self.records[self.rowIndex].payMethodId =
                self.editObj.payMethodId;
              self.records[self.rowIndex].payMethodName =
                self.editObj.payMethodName;
              self.records[self.rowIndex].remark = self.editObj.remark;
              self.records[self.rowIndex].voucher = self.editObj.voucher;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    //-----
    dataProvider(params) {
      return BalanceInOut.search(params);
    },
  },
};
</script>
